import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class CaseSummaryService {

  constructor(private readonly apiService: ApiService) {}

  createCaseSummary(data:any){

     return this.apiService.post<any>('case-summary', {
      data,
    });
  }
}
